export default "__VITE_ASSET__CPsdSy3B__"